<h2 class="mb-5">{{ 'CANDIDATES.TESTRECORDS' | translate }}</h2>

<div class="row mb-4">
  <div class="col-6">
    <div class="btn btn-primary backButton" (click)="utilsService.goBack(); utilsService.setLastUrl()">
      <i class="fa fa-arrow-left" style="font-size: 15px;"></i> {{ ('COMMON.BACK' | translate).toUpperCase() }}
    </div>
  </div>
</div>

<div class="card mb-4 border-0 shadow-sm" *ngIf="candidate">
  <div class="card-body">
    <div class="row">
      <div class="col-md-5">
        <div>{{ 'CANDIDATES.NAMESURNAME' | translate }}</div>
        <h6>{{ ((candidate.name || '') + ' ' + (candidate.surnameComplete || ''))| titlecase }}</h6>
      </div>
      <div class="col-md-2">
        <div>{{ 'COMMON.DOCUMENT' | translate }}</div>
        <h6>{{ candidate.idCard }}</h6>
      </div>
      <div class="col-md-3">
        <div>{{ 'COMMON.EMAIL' | translate }}</div>
        <h6>{{ candidate.email }}</h6>
      </div>
      <div class="col-md-2 text-right">
        <div>{{ 'COMMON.CANDIDATE' | translate }}</div>
        <h6>{{ candidate.randstadCandidate }}</h6>
      </div>
    </div>
  </div>
</div>

<ct-datatable [items$]="historyInvitations$" (reload)="getHistory($event.page)" class="datatable">
  <thead>
    <tr>
      <th colspan="3" id="results">{{ 'CANDIDATES.ALLRESULTS' | translate }}
        ({{ (historyInvitations$ | async)?.total || 0 }})</th>
      <th colspan="8"></th>
    </tr>
  </thead>
  <thead>
    <tr>
      <th>{{ 'COMMON.INVITATIONID' | translate }}</th>
      <th>{{ 'COMMON.TESTID' | translate }}</th>
      <th>{{ 'COMMON.DATE' | translate }}</th>
      <th>{{ 'COMMON.PROCESS' | translate }}</th>
      <th>{{ 'COMMON.CONSULTANT' | translate }}</th>
      <th>{{ 'COMMON.OFFICE' | translate }}</th>
      <th>{{ 'COMMON.TEST' | translate }}</th>
      <th class="text-center">{{ 'STATUS.LABEL' | translate }}</th>
      <th class="text-center">{{ 'COMMON.PROGRESS' | translate }}</th>
      <th class="text-center">{{ 'CANDIDATES.ACTIONS' | translate }}</th>
    </tr>
  </thead>
  <tbody class="bg-white">
    <ng-container *ngFor="let invitation of (historyInvitations$ | async)?.data">
      <tr *ngFor="let test of (invitation)?.tests">
        <td>{{ invitation.id }}</td>
        <td>{{ test.id }}</td>
        <td>{{ invitation.createdAt | dateformat }}</td>
        <td [ngbTooltip]="invitation.group.name | titlecase" container="body">{{ invitation.group.name | titlecase }}
        </td>
        <td [ngbTooltip]="invitation.consultantEmail" container="body">
          <a href="https://mail.google.com/mail/?view=cm&source=mailto&to={{ invitation.consultantEmail }}"
            target="_blank" rel="noopener noreferrer">{{ invitation.consultantEmail }}</a>
        </td>
        <td [ngbTooltip]="invitation.office.name | titlecase" container="body">{{ invitation.office.name | titlecase }}
        </td>
        <td [ngbTooltip]="utilsService.getTestName(test, invitation)" container="body">
          {{ utilsService.getTestName(test, invitation) }}
        </td>
        <td class="text-center pt-3 position-relative">
          <span *ngIf="test.status.toUpperCase() === 'PENDING'" class="dot orange center"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>
          <span *ngIf="test.status.toUpperCase() === 'ACTIVE'" class="dot green center"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>
          <span *ngIf="test.status.toUpperCase() === 'EXPIRED'" class="dot red center"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>
          <span *ngIf="(test.status.toUpperCase() === 'COMPLETED')" class="dot blue center"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>

        </td>
        <td class="text-center">{{ (test.status.toUpperCase() === 'COMPLETED' ? 100 : test.result.completionPercentage) + '%' }}</td>
        <td class="text-center">
          <ng-container *ngIf="test.status.toUpperCase() === 'COMPLETED'">
            <ng-container *ngIf="test.testModel.origin === 'ct'">
              <i class="fa fa-file mx-1"
                *ngIf="utilsService.ADNTestModelIds.includes(test.testModelId)"
                [ngbTooltip]="'TOOLTIP.REPORTS' | translate"
                [routerLink]="'/consultant/reports/invitation/' + invitation.id + '/test/' + test.id"
                (click)="utilsService.setLastUrl()">
              </i>
              <i class="fa fa-file mx-1"
                *ngIf="!utilsService.ADNTestModelIds.includes(test.testModelId)"
                [ngbTooltip]="'TOOLTIP.REPORTS' | translate"
                [routerLink]="'/consultant/reports-ct/invitation/' + invitation.id + '/test/' + test.id"
                (click)="utilsService.setLastUrl()">
              </i>
            </ng-container>
            <a class="fa fa-file mx-1"
              *ngIf="test.testModel.origin === 'evalualia'"
              [ngbTooltip]="'TOOLTIP.REPORT' | translate"
              (click)="utilsService.setLastUrl(); getEvalualiaReport(test.id, invitation.candidate.randstadCandidate, invitation.id, invitation.officeId)">
            </a>
          </ng-container>

          <i class="fa fa-bell mx-1"
            *ngIf="test.status.toUpperCase() === 'PENDING' || test.status.toUpperCase() === 'ACTIVE'"
            (click)="sendReminder(invitation)" [ngbTooltip]="'TOOLTIP.SENDREMINDER' | translate">
          </i>

          <ng-container *ngIf="HCC.includes(invitation.office?.randstadOffice) && HCC.includes(consultant.office.randstadOffice) && invitation.token">

            <i *ngIf="(test.status.toUpperCase() === 'PENDING' || test.status.toUpperCase() === 'ACTIVE')"
              class="fa fa-link mx-1" (click)="copyCandidateHomeLink(invitation?.token)"
              [ngbTooltip]="'TOOLTIP.COPY'  | translate">
            </i>
          </ng-container>

        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!(historyInvitations$ | async)?.data?.length">
      <td colspan="11" class="text-center">{{ 'CANDIDATES.NORESULTS' | translate }}</td>
    </tr>
  </tbody>
</ct-datatable>

<ct-invite></ct-invite>
